<template>
<div class="chapter">
<div class="inner_page">
<div id="Chapter04">
<p class="chap-title">CHRISTMAS</p>
<p class="author"><em class="italic">Kurt Tucholsky</em></p>
<p class="imagec"><img alt="image" src="images/f0011-01.jpg" width="10%"/></p>
<div class="poem">
<p class="poem">Thus standing ’fore the German rubble</p>
<p class="poem">I meekly sing my Christmas song.</p>
<p class="poem">I’ll neither heed nor need to trouble</p>
<p class="poem">with all the wide world’s right and wrong.</p>
<p class="poem">That’s for others. Laid upon us.</p>
<p class="poem">I hum so soft, the sound near gone,</p>
<p class="poem">that tune with all its youthful promise:</p>
<p class="poem1">O Tannenbaum!</p>
</div>
<div class="poem">
<p class="poem">Were I Knecht Ruprecht spreading blessings</p>
<p class="poem">and saw this pandemonium</p>
<p class="poem">—the Germans have no use for lessons—</p>
<p class="poem">God knows! I’d turn the way I’d come.</p>
<p class="poem">The last of the breadcorn’s falling, blighted.</p>
<p class="poem">The alleys bare their teeth and foam.</p>
<p class="poem">I’d drape them from your boughs delighted,</p>
<p class="poem1">O Tannenbaum!</p>
</div>
<div class="poem">
<p class="poem">I stare into the candles crackling:</p>
<p class="poem">Who holds the guilt that runs so deep?</p>
<p class="poem">Who threw us into blood, and cackling?</p>
<p class="poem">Us Germans, patient as the sheep?</p>
<p class="poem">They do not mourn. They man their station.</p>
<p class="poem">I dreamt my dream I thought was gone</p>
<p class="poem">Close off and cease their arrogation!</p>
<p class="poem">Ignore the scoundrels’ cruel predation!</p>
<p class="poem">Then sing with Christmas liberation:</p>
<p class="poem1">O Tannenbaum! O Tannenbaum!</p>
<p class="right"><em class="italic">1918</em></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Chapter04.vue?61d4359a